import { useState } from 'react'
import { Link, Navigate, useLocation } from 'react-router-dom'
import { useHubAuth } from '@/context/HubAuthContext'
import { signIn } from '@/services/auth-supabase'
import { cn } from '@/lib/utils'

export default function HubLogin() {
  const { user, loading } = useHubAuth()
  const location = useLocation()
  const from = location.state?.from || '/hub'

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  if (!loading && user) {
    return <Navigate to={from} replace />
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSubmitting(true)
    const res = await signIn(email, password)
    setSubmitting(false)
    if (!res.success) {
      setError(res.error || 'Sign in failed')
      return
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <p className="text-center font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
          Project Hub
        </p>
        <h1 className="mt-3 text-center text-lg font-semibold text-foreground">Sign in</h1>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="block text-xs font-medium text-muted-foreground" htmlFor="hub-email">
              Email
            </label>
            <input
              id="hub-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-md border border-input bg-card px-3 py-2 text-sm text-foreground outline-none ring-0 focus:border-muted-foreground/40"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-muted-foreground" htmlFor="hub-password">
              Password
            </label>
            <input
              id="hub-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-md border border-input bg-card px-3 py-2 text-sm text-foreground outline-none focus:border-muted-foreground/40"
              required
            />
          </div>
          {error ? <p className="text-xs text-red-400">{error}</p> : null}
          <button
            type="submit"
            disabled={submitting}
            className={cn(
              'w-full rounded-md bg-foreground py-2 text-sm font-medium text-background transition hover:opacity-90',
              submitting && 'opacity-60'
            )}
          >
            {submitting ? 'Signing in…' : 'Continue'}
          </button>
        </form>

        <p className="mt-8 text-center text-xs text-muted-foreground">
          <Link to="/" className="underline underline-offset-4 hover:text-foreground">
            Back to front page
          </Link>
        </p>
      </div>
    </div>
  )
}
